// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"6772394d","53":"7b14d43d","477":"88b01413","587":"e10d3d9e","971":"31221c5d"}[chunkId] + ".css";
};